import * as React from "react";
import ReactPDF, { View, Text } from "@react-pdf/renderer";
import { TReport6ReportPresentationModel } from "../../../presenter/report/model/Report6ReportPresentationModel";
import { TTranslate } from "../../../service/locale/TranslationService";

const Report6PDFTemplateRiskCriteriasGrid = ({
  report,
  styles,
  translate
}: {
  report: TReport6ReportPresentationModel;
  styles: ReactPDF.Styles;
  translate: TTranslate;
}) => {
  const riskCriterias = report.riskCriterias;
  return (
    <View style={{ margin: 20 }}>
      <Text style={styles.regularText}>
        {translate("report6_preview_risk_criterias_gid.title")}
      </Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.subTableCol}>
            <Text style={styles.tableCell}>
              {translate("report6_preview_risk_criterias_gid.name")}
            </Text>
          </View>
        </View>
        {riskCriterias.map((item, index) => (
          <View key={index} style={styles.tableRow}>
            <View style={styles.subTableCol}>
              <Text style={styles.tableCell}>{item.name}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};
export default Report6PDFTemplateRiskCriteriasGrid;
